<template functional>
  <div>
    <strong v-if="props.showLabel">Price: </strong>
    <span v-if="props.availability.will_not_sell">
      WNS
    </span>
    <span v-else-if="props.availability.sale">
      <span v-if="$options.methods.isValuePresent(props.availability.sale.asking_price) || $options.methods.isValuePresent(props.availability.sale.asking_price_sf)">
        <template v-if="props.showPrice">
          <component
            :is="$options.components.Label"
            :value="$options.methods.isValuePresent(props.availability.sale.asking_price) ? $options.filters.formatCurrencyNoDecimal(props.availability.sale.asking_price) : null"
          />
          <template v-if="props.showPsf">
            <component
              :is="$options.components.Label"
              v-if="props.availability.sale.type === 'perAcre'"
              :value="$options.methods.isValuePresent(props.availability.sale.asking_price_acre) ? `(${$options.filters.formatCurrency(props.availability.sale.asking_price_acre)} PPA)` : null"
            />
            <component
              :is="$options.components.Label"
              v-else
              :value="$options.methods.isValuePresent(props.availability.sale.asking_price_sf) ? `(${$options.filters.formatCurrency(props.availability.sale.asking_price_sf)} PSF)` : null"
            />
          </template>
        </template>
        <template v-else-if="props.showPsf">
          <component
            :is="$options.components.Label"
            v-if="props.availability.sale.type === 'perAcre'"
            :value="$options.methods.isValuePresent(props.availability.sale.asking_price_acre) ? `(${$options.filters.formatCurrency(props.availability.sale.asking_price_acre)} PPA)` : null"
          />
          <component
            :is="$options.components.Label"
            v-else
            :value="$options.methods.isValuePresent(props.availability.sale.asking_price_sf) ? `(${$options.filters.formatCurrency(props.availability.sale.asking_price_sf)} PSF)` : null"
          />
        </template>
        <v-tooltip v-if="props.availability.sale.private === true && !props.hideIcons" top>
          <template #activator="{ on, attrs }">
            <v-avatar
              color="red"
              size="16"
              v-bind="attrs"
              class="ml-1"
              v-on="on"
            >
              <span class="white--text text-caption">P</span>
            </v-avatar>
          </template>
          <span>The Sales Price is Private</span>
        </v-tooltip>
        <v-tooltip v-if="props.availability.sale.guidance_price === true && !props.hideIcons" top>
          <template #activator="{ on, attrs }">
            <v-avatar
              color="blue"
              size="16"
              class="ml-1"
              v-bind="attrs"
              v-on="on"
            >
              <span class="white--text text-caption">G</span>
            </v-avatar>
          </template>
          <span>The Sales Price is a guidance price</span>
        </v-tooltip>
      </span>
      <component :is="$options.components.Label" v-else />
    </span>
    <component :is="$options.components.Label" v-else />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'

import { IAvailability } from '@/bundles/Availabilities/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

import Label from '@/bundles/Common/components/Label.vue';

export default Vue.extend({
  name: 'AvailabilitySalesPriceLabel',

  components: {
    Label
  },

  props: {
    availability: {
      type: Object as PropType<IAvailability>,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showPrice: {
      type: Boolean,
      default: true,
    },
    showPsf: {
      type: Boolean,
      default: true,
    },
    hideIcons: Boolean,
  },

  methods: {
    isValuePresent,
  }
})
</script>
